import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ISubscription } from '../interfaces/graph-types';

@Injectable()
export class WatchAccountService {
  private _accountId: BehaviorSubject<string>;

  public subscription: BehaviorSubject<ISubscription> = new BehaviorSubject<
    ISubscription
  >(null);
  public isTrial: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public isExpired: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    null,
  );
  public pendingPayment: BehaviorSubject<boolean> = new BehaviorSubject<
    boolean
  >(null);

  public pastDue: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  // -------------------------------------------------------------------
  constructor() {
    this._accountId = new BehaviorSubject<string>(null);
  }

  // -------------------------------------------------------------------
  public accountId(): BehaviorSubject<string> {
    return this._accountId;
  }

  // -------------------------------------------------------------------
  public resetInfo() {
    this.isTrial.next(false);
    this.isExpired.next(false);
    this.pastDue.next(false);
    this.pendingPayment.next(false);
  }
}
